<template>
  <el-tooltip :placement="placement" :class="`custom-tooltip ${tooltipClass}`" :popper-class="popperClass">
    <!-- Vue 2: $slots.buttonContent is vnodes array or undefined — reliable presence check -->
    <!-- Vue 3 migration: $slots.buttonContent becomes a function, check remains valid -->
    <el-button v-if="$slots.buttonContent">
      <slot name="buttonContent" />
    </el-button>
    <span v-else>
      <slot />
    </span>
    <div slot="content">
      <slot name="content">{{ content }}</slot>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    placement: {
      type: String,
      default: () => 'top',
    },
    content: {
      type: String,
      default: () => '',
    },
    tooltipClass: {
      type: String,
      default: () => '',
    },
    popperClass: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.custom-tooltip {
  border: none;
  padding: 0;

  &:hover {
    background-color: transparent;
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.custom-tooltip.custom-tooltip {
  background-color: transparent;
}
</style>
